import React from "react"

import { Element, Image } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"

interface OwnProps {
  aspectRatio?: Maybe<string>
  height?: Maybe<string>
  imgAlt: Maybe<string>
  imgUrl: Maybe<string>
  width?: Maybe<string>
}

export type ImageProps = OwnProps

const HeroImage: React.FC<ImageProps> = ({
  aspectRatio,
  height,
  imgAlt,
  imgUrl,
  width,
}): React.ReactElement | null => {
  if (!imgAlt || !imgUrl) return null

  return (
    <Element m={["0 auto 20px", "0 auto 30px"]} maxWidth="100%">
      <Image
        aspectRatio={aspectRatio}
        height={height}
        imageData={{ alt: imgAlt, url: imgUrl }}
        maxWidth="100%"
        width={width}
      />
    </Element>
  )
}

export default HeroImage
